// The contact details the owner asks their customers for (the widget settings' Customer tab), in the order the contact
// popup shows them. SubmitQuoteService requires each asked field and checks it.
const CUSTOMER_CONTACT_FIELDS = [
  {
    name: 'customer_email',
    asked: 'askCustomerEmail',
    type: 'email',
    autoComplete: 'email',
    inputMode: 'email',
    label: 'quote_builder_widget.customer_email',
    placeholder: 'quote_builder_widget.customer_email_placeholder',
  },
  {
    name: 'customer_phone',
    asked: 'askCustomerPhone',
    type: 'tel',
    autoComplete: 'tel',
    inputMode: 'tel',
    label: 'quote_builder_widget.customer_phone',
    placeholder: 'quote_builder_widget.customer_phone_placeholder',
  },
];

const askedCustomerContactFields = (asked) => CUSTOMER_CONTACT_FIELDS.filter((field) => asked[field.asked]);

export default askedCustomerContactFields;
